import { useContext, useEffect, useState } from "react";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { getOfferDetailsOfServiceRoute, getSimCardRoute, IS_ON_COLLECTION_ROUTE } from "@api-routes";
import {
    getResponseToStateCustomerOffer,
    getResponseToStateSimCard,
    IOfferDetailsResponse,
    ISimCard,
    ISimCardResponse,
} from "../mappers/getOfferDetailsMapper";
import { IOffer } from "../interface/IOffer";
import { useFetch } from "@common/hook/useFetch";

export const useGetOfferDetails = () => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [getSimCardState, { get: getSimCard }] = useFetch();
    const [getOfferDetailState, { get: getOfferDetail }] = useFetch();
    const [getIsInCollectionState, { get: getIsInCollection }] = useFetch();
    const [offerDetail, setOfferDetail] = useState<IOffer>();
    const [simCard, setSimCard] = useState<ISimCard>();
    const [isInCollection, setIsInCollection] = useState<boolean | undefined>(false);

    useEffect(() => {
        if (selectedService) {
            getOfferDetail<IOfferDetailsResponse>(getOfferDetailsOfServiceRoute(selectedService.id)).then(
                (responses) => {
                    if (responses) {
                        setOfferDetail(getResponseToStateCustomerOffer(responses));
                    }
                }
            );
            getSimCard<ISimCardResponse>(getSimCardRoute(selectedService.id)).then((responses) => {
                if (responses) {
                    setSimCard(getResponseToStateSimCard(responses));
                }
            });
            getIsInCollection<boolean>(IS_ON_COLLECTION_ROUTE).then((response) => {
                setIsInCollection(response);
            });
        }
    }, [getOfferDetail, getSimCard, selectedService]);

    return { simCard, offerDetail, isInCollection, getSimCardState, getOfferDetailState, getIsInCollectionState };
};
